module.exports = __webpack_public_path__ + "img/收藏服务商.f7997a65.png";